import 'qtip2/dist/basic/jquery.qtip';
import { GetBreakpointWidth } from 'Utils/globals-bp';
import { updateQueryStringWithoutHistory } from 'Utils/global';
import { /*showSection,*/ hideSection } from 'Utils/section';
import { scrollToSearchResults } from 'Utils/ha-search-results-functions';
import { scrollToHotelPrices } from 'Utils/ha-search-single-result-functions';
import { ScrollToSearchBarForDropDown } from 'Vendors/groupedSelect/groupedSelect-functions.js';


export function InitScript_searchbar() {
    $('.searchbutton, .view-all-hotels').click(function (event) {
        //var result = true;
        //var a = searchViewModel.Rooms();
        //$.each(searchViewModel.Rooms(), function (i, r) {
        //    if (r.Children().length > 0) {
        //        var arr = $.grep(r.Children(), function (c) { return c.Age() === "" });
        //        result &= arr.length == 0;
        //    }
        //});
        //if (!result) {
        //    //not valid
        //    alert(AppData.Translations["set_children_ages"]);
        //    event.preventDefault();
        //    event.stopPropagation();
        //    return;
        //}
        if (!searchViewModel.ValidateSearchConditions_Rooms(true)) {
            event.preventDefault();
            event.stopPropagation();
            return;
        }
        var flgHotel = false;
        if (searchViewModel.IsHotel()) {
            // Make sure dates are filled
            if (searchViewModel.DepartureDate() == null || searchViewModel.ReturnDate() == null) {
                $('.hotel-search-box .validate').show();
            } else {
                $('.hotel-search-box .validate').hide();
            }
            flgHotel = searchViewModel.IsCurrentPageId();
        }
        /* // 2018-01-15 Use CurrentPageId to show HotelName in SearchBar.DestinationID 
            updateQueryStringWithoutHistory();
            searchViewModel.RequestSearch(true);
        } else { */
        //if (searchViewModel.PageID() == "") {
        //    alert(AppData.Translations["choose_country_or_destination"]);
        //    event.preventDefault();
        //    event.stopPropagation();
        //    return;
        //}
        if (!searchViewModel.ValidateSearchConditions_PageID(true)) {
            event.preventDefault();
            event.stopPropagation();
            return;
        }
        if (!searchViewModel.ValidateSearchConditions_DepartureAirportCode(true)) {
            //FIXME 2019-10-15 :EA: disabled search because "Flight+Hotel" (hotelonly == false) is default and DepartureAirportCode is empty
            event.preventDefault();
            event.stopPropagation();
            return;
        }

        /*
        // 2018-01-15 Use CurrentPageId to show HotelName in SearchBar.DestinationID 
        var hasViewForResults = document.getElementById('search-results') || document.getElementById('prices');
        
        // TODO 2017-12-28 ST Temporary back to version without redirecttion to '/search'
        if (!hasViewForResults || searchViewModel.PageID() != AppData.CurrentPageId) {

            var slug = "";
            if (searchViewModel.DestinationSelector())
            {
                var page = searchViewModel.DestinationSelector().GetDestinationById(searchViewModel.PageID());
                if (page) {
                    slug = page.DataSlug();
                }
            }

            // We cannot show search results on this page. Send user to the selected destination and do the search there.
            window.location = "/" + slug + searchViewModel.GetCurrentQuery() + "#search-results";
        } else {
            if (!searchViewModel.IsHotel()) {
                scrollToSearchResults();
            };
            updateQueryStringWithoutHistory();
            searchViewModel.RequestSearch(false);
        }
        */

        var flgRedirect = !searchViewModel.IsSearch();
        if (flgHotel) {
            // Don't redirect to Search page 
            // when selected DestinationID is CurrentHotelPage on HotelPage 
            flgRedirect = false;
        }
        //var hasViewForResults = document.getElementById('search-results') || document.getElementById('prices');
        //if (hasViewForResults && searchViewModel.PageID() == AppData.CurrentPageId) {
        //    // Don't redirect to Search page 
        //    // when selected DestinationID is CurrentPage and this page has search-results view 
        //    flgRedirect = false;
        //}
        //// ST flow: don't redirect if it's pressed 'in section'
        //var flgInSection = $(this).hasClass('searchbutton-in-section');
        //if (!flgHotel && !flgInSection && !searchViewModel.IsFrontPage() && !searchViewModel.IsSearch()) {
        //    // Redirect to Search page in new tab
        //    // when searchbutton-in-header was clicked
        //    flgRedirect = true;
        //}
        //
        //// HW flow: don't redirect if same page
        //if ($(this).closest('.searchbar-sticky').length > 0 && !searchViewModel.IsSearch()) {
        //    flgRedirect = searchViewModel.PageID() != AppData.CurrentPageId;
        //}


        if (flgRedirect) {
            //window.location = "/search" + searchViewModel.GetCurrentQuery() /*+ "#search-results"*/;

            window.location = searchViewModel.GetSearchUrl();

            /* //2018-02-07 "Open in same tab" with SearchPage
            var url = "";
            // On FrontPage try open country/destination page
            if (searchViewModel.IsFrontPage() && searchViewModel.DestinationSelector()) {
                var page = searchViewModel.DestinationSelector().GetDestinationById(searchViewModel.PageID());
                if (page && page.DataSlug() && page.DataSlug() != "") {
                    // We cannot show search results on this page. Send user to the selected destination and do the search there.
                    url = "/" + page.DataSlug() + searchViewModel.GetCurrentQuery(true, true) + "#search-results";
                }
            }
            // In all other cases we send user to search page
            // even if could not get DataSlug on prev.condition
            if (!url || url == "") {
                url = "/search" + searchViewModel.GetCurrentQuery() /-*+ "#search-results"*-/;
            }
            window.location = url;
            */

            /* //2018-02-07 "Open in new tab"
            //var url = window.location.protocol + "//" + window.location.host + "/search" + searchViewModel.GetCurrentQuery() /-*+ "#search-results"*-/;
            var url = $(this).attr('href');
            
            //On Front page "Open in same tab"
            //On other pages "Open in new tab"
            if (searchViewModel.IsFrontPage()) {
                //event.preventDefault();
                //event.stopPropagation();
                //window.location = url;
            } else {
                // There is a possibility that a user will have his or her browser security settings such that all pop-ups, 
                // which includes windows opened with window.open(), will be blocked even if the action is initiated by the user.
                // If the window opens, the expression evaluates as, and returns, false.
                // If it fails to open, the expression evaluates as, and returns, true -- meaning that the link opens normally (but in the same window).
                return !window.open(url, '_blank');
            }
            */
            // ... "Open in new tab" as simple link ...
            // exclude FrontPage --> "Open in same tab"
        } else {
            event.preventDefault();
            event.stopPropagation();

            if (!searchViewModel.IsHotel() && AppData.ScrollSettings.SearchResults) {
                scrollToSearchResults(true);
            };
            if (searchViewModel.IsHotel() && AppData.ScrollSettings.SearchResults) {
                // uses rAF (requestAnimationFrame) 
                // for catching correct postion of scrollTop in 2nd 'animation'
                // after 1st 'animation' where there are hide-show sections
                if (typeof setVisibleSearchCriteria != "undefined") {
                    AppLoader.raf(function () {
                        setVisibleSearchCriteria(true);
                    });
                }
                AppLoader.raf(function () {
                    scrollToHotelPrices(0, 500);
                }, 64);
            };
            updateQueryStringWithoutHistory();
            searchViewModel.RequestSearch(false);
        }

        /*} // 2018-01-15 Use CurrentPageId to show HotelName in SearchBar.DestinationID */
    });

    $(document).on('click', '.show-rooms-selector-label', function () {
        var $label = $(this);
        var $roomSelector = $label.parent().find('.show-rooms-selector');
        if (!$label.hasClass('open')) {
            $roomSelector.trigger('click');
        }
    });

    $(document).on('click', '.show-rooms-selector', function () {
        $(".input-wrapper").removeClass('open');
        var $roomSelector = $(this);
        var parent = $(this).parents('.rooms-persons');
        var $input_wrapper = $roomSelector.parents(".input-wrapper");
        $input_wrapper.addClass('open');
        var $labelRoomSelector = parent.find('.show-rooms-selector-label');

        // qtip classes with '.faded'
        var classes = 'rooms-selector';
        var $header = $roomSelector.parents('.header');
        if ($header.length > 0) {
            if (!$header.hasClass('searchpage')) {
                classes += " faded";
            }
        }
        classes += " vh-max-height";
        if ($roomSelector.hasClass('is-sticky-parent')) {
            classes += " is-sticky-parent";
        }

        var posMy = 'top center';
        var posAt = 'bottom center';
        var pLeft = 0;
        var $addon = $(this).prev('.addon');
        if ($addon.length > 0) {
            posMy = 'top left';
            posAt = 'bottom left';
            pLeft = $addon.outerWidth() * -1;
        }

        var qtip = $roomSelector.qtip('api');
        if (qtip && $roomSelector.hasClass('open')) {
            qtip.hide();
            return;
        }

        function fixQtipAdjust($roomSelector, $roomSelectorContainerQtip) {
            //$roomSelector
            var api = $roomSelector.qtip('api');

            if (!$roomSelectorContainerQtip) {
                $roomSelectorContainerQtip = api.elements.tooltip;
            }
            var isModalMode = $roomSelectorContainerQtip.hasClass("modal");
            if (isModalMode) {
                api.set('position.adjust.x', 0);
                $roomSelectorContainerQtip.css({ "width": '' });
                $roomSelectorContainerQtip.css({ "maxWidth": '' });
            } else {
                var $form = $roomSelector.parents(".search .searchbar-body"); // use 'fieldset'
                var leftForm = $form.offset().left;
                var leftTarget = $roomSelector.offset().left;
                var currLeft = leftForm - leftTarget;

                var rightForm = leftForm + $form.outerWidth();  // without margin (on HW form is centered by margin)
                var rightTarget = leftTarget + $roomSelector.outerWidth(true);
                var currRight = rightForm - rightTarget;

                var newWidth = $form.outerWidth(true);
                var bp_Width = GetBreakpointWidth();


                api.set('position.my', 'top left');
                api.set('position.at', 'bottom left');
                api.set('position.adjust.x', currLeft);

                //if (bp_Width < 1024) {
                //    //options for bp2 and down
                //    //Note: HW version is temporarily solution while we have date-pickers with HW-style
                //    if ($roomSelector.hasClass('qtip-left')) {
                //        //HW version uses extra class "qtip-left"
                //        if (bp_Width >= 768) {
                //            api.set('position.my', 'top right');
                //            api.set('position.at', 'bottom right');
                //            api.set('position.adjust.x', currRight);
                //            //for not-small screen use half of width
                //            newWidth = newWidth / 2;
                //        } else {
                //            api.set('position.my', 'top left');
                //            api.set('position.at', 'bottom left');
                //            api.set('position.adjust.x', currLeft);
                //        }
                //    } else {
                //        //ST version
                //        api.set('position.my', 'top left');
                //        api.set('position.at', 'bottom left');
                //        api.set('position.adjust.x', currLeft);

                //        if (bp_Width >= 768) {
                //            //options for bp2
                //            //for not-small screen use width of parent
                //            newWidth = $roomSelector.parents(".input-wrapper").outerWidth(true);
                //        } else {
                //            //for small screen use full width
                //            //newWidth = newWidth / 2;
                //        }
                //    }
                //} else {
                //    //options for bp3 and up
                //    //Note: HW version is temporarily solution while we have date-pickers with HW-style
                //    //Check if use HW version
                //    var flgHWversion = $roomSelector.hasClass('qtip-left') && ((rightForm - leftTarget) >= 360);
                //    if (flgHWversion) {
                //        //HW version uses extra class "qtip-left"
                //        api.set('position.my', 'top left');
                //        api.set('position.at', 'bottom left');
                //        api.set('position.adjust.x', 0);
                //        //for not-small screen use space between leftTarget and rightForm
                //        newWidth = rightForm - leftTarget;
                //    } else {
                //        //ST version
                //        api.set('position.my', 'top right');
                //        api.set('position.at', 'bottom right');
                //        api.set('position.adjust.x', currRight);
                //        //for not-small screen use half of width
                //        newWidth = newWidth / 2;
                //    }
                //}

                $roomSelectorContainerQtip.css({ "width": newWidth });
                $roomSelectorContainerQtip.css({ "maxWidth": newWidth });
            }

        }

        function fixQtipScrollTop(api) {
            if (!api)
                return;

            var holder = api.target;
            var windowHeight = $(window).height();
            var offset = windowHeight / 2;

            if (holder.outerHeight() >= offset) {
                // no sence to scroll
                return;
            }

            var currentTop = $(window).scrollTop();
            var minTop = currentTop + offset;
            var holderTop = holder.offset().top;

            if (minTop > holderTop) {
                // don't scroll if holder is located near top of screen
                return;
            }

            // height of dropdown's inner-view: 70vh;
            // padding-bottom of dropdown: 16px;
            //var maxHeightOfDropdown = api.tooltip.outerHeight();
            var maxHeightOfDropdown = windowHeight * 0.7 + 16;

            // space between control and dropdown: ~29-30px
            var marginTop = parseInt(api.tooltip.css("margin-top"));
            //var marginTop = 30;

            // chat's space at window's bottom: 40px (height 30px + 10px bottom)
            var maxHeight = holder.outerHeight() + marginTop + maxHeightOfDropdown + 40;
            var maxOffset = windowHeight - maxHeight;

            var halfOffset = offset / 2;
            if (halfOffset > maxOffset) {
                offset = maxOffset;
            } else {
                offset = halfOffset;
            }

            $('html, body').stop().animate({
                scrollTop: holder.offset().top - offset
            }, 300);
        }

        function updateQtipModalMode(useModalMode, api, $dropdownContainerQtip) {
            if (useModalMode) {
                $('.qtip.rooms-selector').addClass("modal");
                $('html').addClass("noscroll");

                $('.qtip.rooms-selector .close').off('click');
                $('.qtip.rooms-selector .modal-close').on('click', function (e) {
                    if (api) {
                        api.hide();
                    }
                });
            } else {
                $('html').removeClass("noscroll");
                $('.qtip.rooms-selector').removeClass("modal");

                $('.qtip.rooms-selector .modal-close').off('click');
                $('.qtip.rooms-selector .close').on('click', function (e) {
                    if (api) {
                        api.hide();
                    }
                });
            }

        }

        function fixModalHeadHeight() {
            var $contentHead = $('.qtip.rooms-selector .modal-head');
            var $stickyWrapper = $contentHead.parent('.sticky-wrapper');
            if ($stickyWrapper.length == 0) {
                var wrapper = $('<div></div>')
                  .addClass('sticky-wrapper');
      
                  $contentHead.wrapAll(wrapper)
                  $stickyWrapper = $contentHead.parent('.sticky-wrapper');
            }
            $stickyWrapper.css('height', $contentHead.outerHeight(true));
        };
        fixModalHeadHeight();

        function resizer() {
            let qtip = $roomSelector.qtip('api');
            if (qtip && qtip.isShowing) {

                var $dropdownContainerQtip = $('.qtip.rooms-selector');
                var isModalMode = $dropdownContainerQtip.hasClass("modal");
                var useModalMode = GetBreakpointWidth() < 768;

                if (useModalMode != isModalMode) {
                    updateQtipModalMode(useModalMode, qtip, $dropdownContainerQtip);
                }

                fixModalHeadHeight();
                fixQtipAdjust($roomSelector);
            }
        };

        $(this).qtip({
            show: {
                event: 'click',
                ready: true,
                solo: true,
            },
            overwrite: 'false',
            hide: 'unfocus',
            content: {
                text: $('#rooms-selector-temp').html() //text: $('.rooms-selector').html()
            },
            position: {
                target: $(this), //$('.rooms-persons'),
                my: posMy, //my: 'top center',
                at: posAt, //at: 'bottom center',
                tooltip: 'topMiddle',
                //viewport: $(window),
                //viewport:true,
                adjust: {
                    x: pLeft,
                    y: 0
                },
                //effect: false //no-animation
                effect: function (api, pos) {
                    //The default animation callback
                    //$(this).animate(pos, { duration: 200, queue: FALSE });

                    //fix animation when searchbar becomes sticky => no-sticky
                    if (api.elements.target.hasClass('is-sticky-parent')) {
                        var window_top = $(window).scrollTop();
                        pos.top = window_top + 51;
                    }
                    $(this).animate(pos, { duration: 0, queue: false });
                }
            },
            style: {
                classes: classes,
                def: false,
            },
            events: {
                hide: function (event, api) {
                    $('.qtip.rooms-selector .modal-close').off('click');
                    $('.qtip.rooms-selector .close').off('click');
                    $('.qtip.rooms-selector').remove();
                    $roomSelector.removeClass('open');
                    $input_wrapper.removeClass('open');
                    $('html').removeClass("noscroll");
                    setTimeout(function () {
                        $labelRoomSelector.removeClass('open');
                    }, 300);
                    //$('.qtip.rooms-selector .modal-head').unstick();
                    $(window).off("resize", resizer);
                    if (api) api.isShowing = false;
                },
                render: function (event, api) {
                    ko.applyBindings(searchViewModel, api.elements.tooltip[0]);
                    //ko.applyBindings(searchViewModel, $('.rooms-selector')[0]);
                    $roomSelector.addClass('open');
                    $labelRoomSelector.addClass('open');
                    //$('.qtip.rooms-selector .modal-head').sticky({ topSpacing: 0, zIndex: 5, widthFromWrapper: false });
                    api.tooltip.bind('remove', function () {
                        //console.log('unstick ' + $('.qtip.rooms-selector .modal-head').length + ' items');
                        //$('.qtip.rooms-selector .modal-head').unstick();
                    });
                },
                show: function (event, api) {
                    //event.preventDefault(); // Stop it!
                    if (api) api.isShowing = true;
                    var $dropdownContainerQtip = $('.qtip.rooms-selector');
                    var useModalMode = GetBreakpointWidth() < 768;
                    updateQtipModalMode(useModalMode, api, $dropdownContainerQtip);

                    if (useModalMode) {
                        setTimeout(function () {
                            fixModalHeadHeight();
                        }, 100);

                        /* On some mobile browser when the overlay was previously
                        opened and scrolled, if you open it again it doesn't 
                        reset its scrollTop property */
                        //$dropdownContainerQtip.scrollTop = 0;
                    } else {
                        fixQtipScrollTop(api);
                    }
                    fixQtipAdjust($roomSelector, $dropdownContainerQtip);
                    $(window).resize(resizer);
                }
            }
        });
    });

    $(document).on('click', '.additional-options-selector', function () {
        if (GetBreakpointWidth() < 768 && searchViewModel.IsSearch()) {
            $('#sidebarSearchResults .item-filter').click();
        } else {
            $(".input-wrapper").removeClass('open');
            var $additionalOptionsSelector = $(this);
            var parent = $(this).parents('.additional-search-options');
            var $input_wrapper = $additionalOptionsSelector.parents(".input-wrapper");
            $input_wrapper.addClass('open');
            var $labelRoomSelector = parent.find('.show-additional-options-qtip-label');

            // qtip classes with '.faded'
            var classes = 'additional-options-qtip';
            var $header = $additionalOptionsSelector.parents('.header');
            if ($header.length > 0) {
                if (!$header.hasClass('searchpage')) {
                    classes += " faded";
                }
            }
            classes += " vh-max-height";
            if ($additionalOptionsSelector.hasClass('is-sticky-parent')) {
                classes += " is-sticky-parent";
            }

            var posMy = 'top center';
            var posAt = 'bottom center';
            var pLeft = 0;
            var $addon = $(this).prev('.addon');
            if ($addon.length > 0) {
                posMy = 'top left';
                posAt = 'bottom left';
                pLeft = $addon.outerWidth() * -1;
            }

            var qtip = $additionalOptionsSelector.qtip('api');
            if (qtip && $additionalOptionsSelector.hasClass('open')) {
                qtip.hide();
                return;
            }

            function fixQtipAdjust($additionalOptionsSelector, $additionalOptionsSelectorContainerQtip) {
                //$additionalOptionsSelector
                var api = $additionalOptionsSelector.qtip('api');

                if (!$additionalOptionsSelectorContainerQtip) {
                    $additionalOptionsSelectorContainerQtip = api.elements.tooltip;
                }
                var isModalMode = $additionalOptionsSelectorContainerQtip.hasClass("modal");
                if (isModalMode) {
                    api.set('position.adjust.x', 0);
                    $additionalOptionsSelectorContainerQtip.css({ "width": '' });
                    $additionalOptionsSelectorContainerQtip.css({ "maxWidth": '' });
                } else {
                    var $form = $additionalOptionsSelector.parents(".search .searchbar-body"); // use 'fieldset'
                    var leftForm = $form.offset().left;
                    var leftTarget = $additionalOptionsSelector.offset().left;
                    var currLeft = leftForm - leftTarget;

                    var rightForm = leftForm + $form.outerWidth();  // without margin (on HW form is centered by margin)
                    var rightTarget = leftTarget + $additionalOptionsSelector.outerWidth(true);
                    var currRight = rightForm - rightTarget;

                    var newWidth = $form.outerWidth(true);
                    var bp_Width = GetBreakpointWidth();


                    api.set('position.my', 'top left');
                    api.set('position.at', 'bottom left');
                    api.set('position.adjust.x', currLeft);

                    $additionalOptionsSelectorContainerQtip.css({ "width": newWidth });
                    $additionalOptionsSelectorContainerQtip.css({ "maxWidth": newWidth });
                }

            }

            function fixQtipScrollTop(api) {
                if (!api)
                    return;

                var holder = api.target;
                var windowHeight = $(window).height();
                var offset = windowHeight / 2;

                if (holder.outerHeight() >= offset) {
                    // no sence to scroll
                    return;
                }

                var currentTop = $(window).scrollTop();
                var minTop = currentTop + offset;
                var holderTop = holder.offset().top;

                if (minTop > holderTop) {
                    // don't scroll if holder is located near top of screen
                    return;
                }

                var maxHeightOfDropdown = windowHeight * 0.7 + 16;

                // space between control and dropdown: ~29-30px
                var marginTop = parseInt(api.tooltip.css("margin-top"));
                //var marginTop = 30;

                // chat's space at window's bottom: 40px (height 30px + 10px bottom)
                var maxHeight = holder.outerHeight() + marginTop + maxHeightOfDropdown + 40;
                var maxOffset = windowHeight - maxHeight;

                var halfOffset = offset / 2;
                if (halfOffset > maxOffset) {
                    offset = maxOffset;
                } else {
                    offset = halfOffset;
                }

                $('html, body').stop().animate({
                    scrollTop: holder.offset().top - offset
                }, 300);
            }

            function updateQtipModalMode(useModalMode, api, $dropdownContainerQtip) {
                if (useModalMode) {
                    $('.qtip.additional-options-qtip').addClass("modal");
                    $('html').addClass("noscroll");

                    $('.qtip.additional-options-qtip .close-qtip').off('click');
                    $('.qtip.additional-options-qtip .modal-close').on('click', function (e) {
                        if (api) {
                            api.hide();
                        }
                    });
                } else {
                    $('html').removeClass("noscroll");
                    $('.qtip.additional-options-qtip').removeClass("modal");

                    $('.qtip.additional-options-qtip .modal-close').off('click');
                    $('.qtip.additional-options-qtip .close-qtip').on('click', function (e) {
                        if (api) {
                            api.hide();
                        }
                    });
                }

            }

            function fixModalHeadHeight() {
                var $contentHead = $('.qtip.additional-options-qtip .modal-head');
                $contentHead.parent('.sticky-wrapper').css('height', $contentHead.outerHeight(true));
            };
            fixModalHeadHeight();

            function resizer() {
                let qtip = $additionalOptionsSelector.qtip('api');
                if (qtip && qtip.isShowing) {

                    var $dropdownContainerQtip = $('.additional-filtering-container .filter-container');
                    var isModalMode = $dropdownContainerQtip.hasClass("modal");

                    fixModalHeadHeight();
                    fixQtipAdjust($additionalOptionsSelector);
                }
            };

            $(this).qtip({
                show: {
                    event: 'click',
                    ready: true,
                    solo: true,
                },
                overwrite: 'false',
                hide: 'unfocus',
                content: {
                    text: $('#additional-search-options-selector').html()
                },
                position: {
                    target: $(this),
                    my: posMy, //my: 'top center',
                    at: posAt, //at: 'bottom center',
                    tooltip: 'topMiddle',
                    adjust: {
                        x: pLeft,
                        y: 0
                    },
                    //effect: false //no-animation
                    effect: function (api, pos) {
                        //The default animation callback

                        //fix animation when searchbar becomes sticky => no-sticky
                        if (api.elements.target.hasClass('is-sticky-parent')) {
                            var window_top = $(window).scrollTop();
                            pos.top = window_top + 51;
                        }
                        $(this).animate(pos, { duration: 0, queue: false });
                    }
                },
                style: {
                    classes: classes,
                    def: false,
                },
                events: {
                    hide: function (event, api) {
                        $('.additional-filtering-container .filter-container .modal-close').off('click');
                        $('.additional-filtering-container .filter-container .close').off('click');
                        $('.additional-filtering-container .filter-container').remove();
                        $additionalOptionsSelector.removeClass('open');
                        $input_wrapper.removeClass('open');
                        $('html').removeClass("noscroll");
                        setTimeout(function () {
                            $labelRoomSelector.removeClass('open');
                        }, 300);
                        $(window).off("resize", resizer);
                        if (api) api.isShowing = false;
                    },
                    render: function (event, api) {
                        ko.applyBindings(searchViewModel, api.elements.tooltip[0]);
                        $additionalOptionsSelector.addClass('open');
                        $labelRoomSelector.addClass('open');
                        //$('.additional-filtering-container .filter-container .modal-head').sticky({ topSpacing: 0, zIndex: 5, widthFromWrapper: false });
                        api.tooltip.bind('remove', function () {
                            //$('.qtip.additional-options-qtip .modal-head').unstick();
                        });
                    },
                    show: function (event, api) {
                        //event.preventDefault(); // Stop it!
                        if (api) api.isShowing = true;
                        var $dropdownContainerQtip = $('.additional-filtering-container .filter-container');
                        var useModalMode = GetBreakpointWidth() < 768;
                        updateQtipModalMode(useModalMode, api, $dropdownContainerQtip);

                        if (useModalMode) {
                            setTimeout(function () {
                                fixModalHeadHeight();
                            }, 100);

                            /* On some mobile browser when the overlay was previously
                            opened and scrolled, if you open it again it doesn't 
                            reset its scrollTop property */
                            //$dropdownContainerQtip.scrollTop = 0;
                        } else {
                            fixQtipScrollTop(api);
                        }
                        fixQtipAdjust($additionalOptionsSelector);
                        $(window).resize(resizer);
                    }
                }
            });
        }
    });

    $(document).on('click', '.open-departure-airports-selector', function (e) {
        e.preventDefault();
        var $this = $(this);

        if (!searchViewModel || !searchViewModel.DepartureAirportSelector())
            return;

        var departureAirportCode = $this.attr("data-departureAirportCode");
        if (departureAirportCode && departureAirportCode != '') {
            searchViewModel.SetDefaultDepartureAirportCode(departureAirportCode);
        }

        var searchbarOutside = $this.attr("data-searchbar-outside");
        var $searchbar = $(e.target).closest('.search');
        if ($searchbar.length < 1 && searchbarOutside && searchbarOutside != '' && searchbarOutside != 'false')
        {
            if(searchbarOutside == 'true' || searchbarOutside == 'first')
                $searchbar = $('.search:first');
            else if (searchbarOutside == 'last')
                $searchbar = $('.search:last');
            else 
                $searchbar = $(searchbarOutside);
        }
        
        if ($searchbar.length < 1)
            return;

        var $dropdown = $searchbar.find('.grouped-select.departure-airport-select');
        if ($dropdown.length < 1)
            return;


        var onlyOnce = $this.attr("data-only-once");
        var autosearchOnce = $this.attr("data-autosearch-once");
        if (this.hasAttribute("data-only-once") && onlyOnce !== 0 && onlyOnce.toLowerCase() !== "false") {
            //onlyOnce = parseInt($this.attr("data-open-once"));
            //if (isNaN(onlyOnce))
            //    onlyOnce = 0;
            //if (onlyOnce > 0) {
            //    return;
            //} else {
            //    $this.attr("data-open-once", onlyOnce+1);
            //}
            if (searchbarLastDepartureAirportClicked && searchbarLastDepartureAirportClicked !== "") {
                return;
            }
        }

        var hideValidation = $this.attr("data-hide-validation");
        if (this.hasAttribute("data-hide-validation") && hideValidation !== 0 && hideValidation.toLowerCase() !== "false") {
            var holder = $('.departureAirportCode-validation');
            hideSection(holder, true);
        }

        var openDepartureAirportselector = function () {
            if (!$dropdown.hasClass('open')) {
                e.stopPropagation();
                $dropdown.trigger('click');
            }

            if ($this[0].hasAttribute("data-autosearch-once") && autosearchOnce !== 0 && autosearchOnce.toLowerCase() !== "false") {
                var subscription = searchViewModel.DepartureAirportSelector().Visible.subscribeChanged(function (newValue, oldValue) {
                    if (subscription.isDisposed) {
                        return;
                    }
                    if (oldValue === true && newValue === false) {
                        // unsubscribe current event, because 'autosearch-once'
                        subscription.dispose();
                        // start search, give some time for animation
                        var startAutoSearch = function () {
                            $('.searchbutton').trigger('click');
                        };
                        setTimeout(startAutoSearch, 300);
                    }
                });
            }
        };

        if (typeof ScrollToSearchBarForDropDown != "undefined") {
            ScrollToSearchBarForDropDown($dropdown, true, openDepartureAirportselector);
        } else {
            openDepartureAirportselector();
        }

    });

    $(document).on('click', '.open-date-range-selector', function (e) {
        e.preventDefault();
        var $this = $(this);

        if (!searchViewModel)
            return;

        var searchbarOutside = $this.attr("data-searchbar-outside");
        var $searchbar = $(e.target).closest('.search');
        if ($searchbar.length < 1 && searchbarOutside && searchbarOutside != '' && searchbarOutside != 'false')
        {
            if(searchbarOutside == 'true' || searchbarOutside == 'first')
                $searchbar = $('.search:first');
            else if (searchbarOutside == 'last')
                $searchbar = $('.search:last');
            else 
                $searchbar = $(searchbarOutside);
        }

        if ($searchbar.length < 1)
            return;

        // $(".input-wrapper").removeClass('open');

        var $dropdown = $searchbar.find('.grouped-select.date-range-selector');
        if ($dropdown.length < 1)
            return;

        var onlyOnce = $this.attr("data-only-once");
        var autosearchOnce = $this.attr("data-autosearch-once");
        if (this.hasAttribute("data-only-once") && onlyOnce !== 0 && onlyOnce.toLowerCase() !== "false") {
            //onlyOnce = parseInt($this.attr("data-open-once"));
            //if (isNaN(onlyOnce))
            //    onlyOnce = 0;
            //if (onlyOnce > 0) {
            //    return;
            //} else {
            //    $this.attr("data-open-once", onlyOnce+1);
            //}
        }

        //var hideValidation = $this.attr("data-hide-validation");
        //if (this.hasAttribute("data-hide-validation") && hideValidation !== 0 && hideValidation.toLowerCase() !== "false") {
        //    var holder = $('.dateRange-validation');
        //    hideSection(holder, true);
        //}

        var openDateRangeSelector = function () {
            //if (!$dropdown.hasClass('open')) {
            //    e.stopPropagation();
            //    $dropdown.trigger('click');
            //}
            var drp = $dropdown.data('daterangepicker');
            if (drp) {
                var isShowing = drp.isShowing || drp.container.is(":visible") || drp.container.css("display") != 'none';
                if (isShowing) {
                    // $this.parents(".input-wrapper").addClass('open');
                } else {
                    e.stopPropagation();
                    //$dropdown.trigger('click');
                    //drp.showCalendars();
                    drp.show();
                }
            }

            if ($this[0].hasAttribute("data-autosearch-once") && autosearchOnce !== 0 && autosearchOnce.toLowerCase() !== "false") {

                var cbApplyDateRangePicker = function (event, picker) {
                    // unsubscribe current event, because 'autosearch-once'
                    $dropdown.off('apply.daterangepicker', cbApplyDateRangePicker);

                    // start search, give some time for animation
                    var startAutoSearch = function () {
                        $('.searchbutton').trigger('click');
                    };
                    setTimeout(startAutoSearch, 300);
                };

                $dropdown.on('apply.daterangepicker', cbApplyDateRangePicker);
            }
        };

        if (typeof ScrollToSearchBarForDropDown != "undefined") {
            ScrollToSearchBarForDropDown($dropdown, true, openDateRangeSelector);
        } else {
            openDateRangeSelector();
        }

    });



};

export function searchbarFixedHeight() {
    var h = 0;
    //var holder = $(".searchbar-fixed");
    //if (holder && (holder.is(':visible') || $(window).width() > 1024)) {
    //    h = h + holder.outerHeight(true);
    //}

    var maxWidth = GetBreakpointWidth();
    var $searchbar = $(".searchbar-sticky");
    if ($searchbar.length > 0 && ($searchbar.css('position') == 'fixed' || maxWidth >= 1280)) {
        //h = h + $searchbar.outerHeight();
        // FIXME: after 'searchbar' re-styling may be other values
        // height of searchbar-sticky:
        // standard mode: 125px;
        // sticky mode: 80px;
        h = 90 + 12;
    }

    return h;
};

export function OpenSearchBarDestinationSelector(callbackOpened) {
    var $dropdown = $('.search .grouped-select.destination-select');
    if ($dropdown.length < 1)
        return;

    var openDestinationSelector = function () {
        if (!$dropdown.hasClass('open')) {
            //e.stopPropagation();
            $dropdown.first().trigger('click');
        }
        if (typeof callbackOpened === "function") {
            callbackOpened($dropdown);
        }
    }

    if (typeof ScrollToSearchBarForDropDown != "undefined") {
        ScrollToSearchBarForDropDown($dropdown.first(), true, openDestinationSelector);
    } else {
        openDestinationSelector();
    }
};

export function OpenSearchBarDepartureAirportSelector(callbackOpened) {
    var $dropdown = $('.search .grouped-select.departure-airport-select');
    if ($dropdown.length < 1)
        return;

    var openDepartureAirportSelector = function () {
        if (!$dropdown.hasClass('open')) {
            //e.stopPropagation();
            $dropdown.first().trigger('click');
        }
        if (typeof callbackOpened === "function") {
            callbackOpened($dropdown);
        }
    }

    if (typeof ScrollToSearchBarForDropDown != "undefined") {
        ScrollToSearchBarForDropDown($dropdown.first(), true, openDepartureAirportSelector);
    } else {
        openDepartureAirportSelector();
    }
};

export function OpenSearchBarRoomSelector(callbackOpened) {
    var $dropdown = $('.search .show-rooms-selector');
    if ($dropdown.length < 1)
        return;

    var openRoomSelector = function () {
        if (!$dropdown.hasClass('open')) {
            //e.stopPropagation();
            $dropdown.first().trigger('click');
        }
        if (typeof callbackOpened === "function") {
            callbackOpened($dropdown);
        }
    }

    if (typeof ScrollToSearchBarForDropDown != "undefined") {
        ScrollToSearchBarForDropDown($dropdown.first(), true, openRoomSelector);
    } else {
        openRoomSelector();
    }
};

export function AfterUpdateSearchBarDepartureAirportSelector(sender) {
    let $select = $(this);
    let $dropdown = $(sender);

    let hotelOnly = searchViewModel.HotelOnly();
    if (hotelOnly) {
        $dropdown.addClass('has-hotelonly');
    } else {
        $dropdown.removeClass('has-hotelonly');
    }
};
